import {
  Avatar,
  Button,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { APP_ICONS } from "../../assets";
import ImageViewDialog from "../imageViewModal";

const tableStyle = {
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: "secondary.light",
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      fontSize: "1rem",
      color: "customColor.scorpion",
      fontWeight: 600,
    },
  "&.MuiTableContainer-root .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root":
    {
      fontSize: "1rem",
      color: "customColor.tundora",
      padding: "10px 16px",
    },

  "& .chip-status": {
    borderRadius: "8px",
    // width: 70,
    padding: "0 10px",
  },
  "& .chip-status .MuiChip-label": {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  "& .withdrawn-status": {
    borderRadius: "8px",
    width: 80,
  },
  "& .withdrawn-status .MuiChip-label": {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  "& .stripe-tab": {
    borderRadius: "8px",
    width: 60,
    height: 30,
    fontWeight: 800,
    color: "#635bff",
    backgroundColor: "customColor.moonRaker",
  },
  "& .stripe-tab .MuiChip-label": {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  "& .action-button": {
    padding: "0px",
    height: 40,
    width: 40,
  },
};

export default function DynamicTable({
  minWidth,
  tableHeader,
  tableData,
  displayRows,
  showPagination,
  showUserMenu,
  showAdminMenu,
  showVendorMenu,
  showWithDrawnMenu,
  showCommissionMenu,
  showRequestMenu,
  showEditAndDelete,
  handleUpdateStatus,
  handleEdit,
  handleDelete,
  showEdit,
  showDelete,
  openDialog,
  handleOpenDialog,
  handleSuspend,
}) {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event, index) => {
    setAnchorEl({ el: event.currentTarget, index });
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const withDrawnStatusColor = (status) => {
    if (status === "Pending")
      return {
        bgColor: "customColor.tequila",
        color: "customColor.tahitiGold",
      };
    if (status === "Approved")
      return {
        bgColor: "customColor.blueRomance",
        color: "customColor.malachite",
      };
    if (status === "Rejected")
      return {
        bgColor: "customColor.palePink",
        color: "customColor.darkRed",
      };
  };

  const sponsoredStatusColor = (status) => {
    if (status === "Pending")
      return {
        bgColor: "customColor.tequila",
        color: "customColor.tahitiGold",
      };
    if (status === "Yes")
      return {
        bgColor: "customColor.blueRomance",
        color: "customColor.malachite",
      };
    if (status === "Withdrawal")
      return {
        bgColor: "customColor.blueRomance",
        color: "customColor.malachite",
      };
    if (status === "No")
      return {
        bgColor: "customColor.palePink",
        color: "customColor.darkRed",
      };
  };

  const userStatusColor = (status) => {
    if (status === "Active")
      return {
        color: "customColor.malachite",
        bgColor: "customColor.blueRomance",
      };
    if (status === "Return Accepted")
      return {
        color: "customColor.malachite",
        bgColor: "customColor.blueRomance",
      };
    if (status === "InActive")
      return {
        color: "customColor.gray",
        bgColor: "customColor.alto",
      };
    if (status === "Pedding")
      return {
        color: "customColor.gray",
        bgColor: "customColor.alto",
      };
  };

  return (
    <>
      <TableContainer sx={tableStyle}>
        <Table
          sx={{
            minWidth: minWidth ? minWidth : "900px",
          }}
        >
          <TableHead>
            <TableRow>
              {tableHeader?.map((header) => (
                <TableCell key={header}>
                  <Typography noWrap>{header}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? tableData?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : tableData
            )?.map((row, index) => {
              console.log(row, "rowrowrowrow");

              const userStatus = row?.status;
              const withdrawmStatus = row?.status;
              const sponsoredStatus = row.status;

              return (
                <TableRow key={index}>
                  {displayRows.map((val) => (
                    <React.Fragment key={val}>
                      {val === "_id" ? (
                        <TableCell>{index + 1}</TableCell>
                      ) : val === "created_at" ? (
                        <TableCell>
                          {moment(row.createdAt).format("MM/DD/YYYY")}
                        </TableCell>
                      ) : val === "delivery_date" ? (
                        <TableCell>
                          {row.deliveryDate
                            ? moment(row.deliveryDate).format("MM/DD/YYYY")
                            : " N/A"}
                        </TableCell>
                      ) : val === "user_id" ? (
                        <TableCell>#{index + 1}</TableCell>
                      ) : val === "phone" ? (
                        <TableCell>{row.phoneNumber}</TableCell>
                      ) : val === "delivered_address" ? (
                        <TableCell>
                          {row.address?.fulladdress}, {row.city}
                        </TableCell>
                      ) : val === "user_data" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.image}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.name}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row.email}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "order_user_data" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.image}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row?.address?.name}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row?.address?.email}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                +{row?.address?.phoneNumber}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "history_user_data" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.image}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.vendorDetails?.name}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row.vendorDetails?.email}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "vendor_data" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.referrerImage}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.referrerName}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row.referrerEmail}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "commission_user" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.vendorImage}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.customerName}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row.customerEmail}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "commission_vendor" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.vendorImage}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.vendorName}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row.vendorEmail}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "reffer_user" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.vendorImage}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.referrerName}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row.referrerEmail}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "user_details" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row?.userId?.image}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row?.userId?.name}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row?.userId?.email}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "product_details" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row?.userId?.image}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row?.productName}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row?.productDescription}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "vendor_details" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row?.vendorId?.image}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row?.vendorId?.name}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row?.vendorId?.email}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "vendor_status" ? (
                        <TableCell>
                          <Chip
                            label={userStatus}
                            className="chip-status"
                            sx={{
                              color: userStatusColor(userStatus)?.color,
                              backgroundColor:
                                userStatusColor(userStatus)?.bgColor,
                            }}
                          />
                        </TableCell>
                      ) : val === "product_price" ? (
                        <TableCell>${row?.productPrice}</TableCell>
                      ) : val === "return_reason" ? (
                        <TableCell>{row?.returnReason}</TableCell>
                      ) : val === "return_description" ? (
                        <TableCell>{row?.returnDescription}</TableCell>
                      ) : val === "return_status" ? (
                        <TableCell>
                          <Chip
                            label={row?.returnOrderStatus}
                            className="chip-status"
                            sx={{
                              color: userStatusColor(row?.returnOrderStatus)
                                ?.color,
                              backgroundColor: userStatusColor(
                                row?.returnOrderStatus
                              )?.bgColor,
                            }}
                          />
                        </TableCell>
                      ) : val === "vendor_status" ? (
                        <TableCell>
                          <Chip
                            label={userStatus}
                            className="chip-status"
                            sx={{
                              color: userStatusColor(userStatus)?.color,
                              backgroundColor:
                                userStatusColor(userStatus)?.bgColor,
                            }}
                          />
                        </TableCell>
                      ) : val === "withDrawn_amount" ? (
                        <TableCell>${row.amount}</TableCell>
                      ) : val === "referral_commission" ? (
                        <TableCell>
                          ${row?.referralCommission?.toFixed(2)}
                        </TableCell>
                      ) : val === "orderId" ? (
                        <TableCell>#{row.orderId}</TableCell>
                      ) : val === "returnOrderId" ? (
                        <TableCell>#{row.returnOrderId}</TableCell>
                      ) : val === "return_images" ? (
                        <TableCell>
                          <Stack
                            direction={{ sm: "row" }}
                            width="100%"
                            flex={2}
                            gap={2}
                            justifyContent={{ md: "flex-end" }}
                          >
                            <Button
                              variant="contained"
                              onClick={() => handleOpenDialog(row)}
                              sx={{ height: 37, width: 150 }}
                            >
                              View Images
                            </Button>
                          </Stack>
                        </TableCell>
                      ) : val === "order_amount" ? (
                        <TableCell>${row.totalBill?.toFixed(2)}</TableCell>
                      ) : val === "tax_amount" ? (
                        <TableCell>${row.taxAmount?.toFixed(2)}</TableCell>
                      ) : val === "withDrawn_status" ? (
                        <TableCell>
                          <Chip
                            label={"Withdrawal"}
                            className="withdrawn-status"
                            sx={{
                              color: withDrawnStatusColor("Approved").color,
                              backgroundColor:
                                withDrawnStatusColor("Approved").bgColor,
                            }}
                          />
                        </TableCell>
                      ) : val === "order_status" ? (
                        <TableCell>
                          <Chip
                            label={row?.status}
                            className="withdrawn-status"
                            sx={{
                              color: withDrawnStatusColor("Approved").color,
                              backgroundColor:
                                withDrawnStatusColor("Approved").bgColor,
                            }}
                          />
                        </TableCell>
                      ) : val === "sponsored_status" ? (
                        <TableCell>
                          <Chip
                            label={"Withdrawal"}
                            className="withdrawn-status"
                            sx={{
                              color: sponsoredStatusColor("Withdrawal")?.color,
                              backgroundColor:
                                sponsoredStatusColor("Withdrawal")?.bgColor,
                            }}
                          />
                        </TableCell>
                      ) : val === "total_sales" ? (
                        <TableCell>${row.totalClearedAmount}</TableCell>
                      ) : val === "total_commission_sales" ? (
                        <TableCell>${row.commissionAmount}</TableCell>
                      ) : val === "total_commission_percenttage" ? (
                        <TableCell>{row.commissionPercentage}%</TableCell>
                      ) : val === "total_commission_amount" ? (
                        <TableCell>${row?.orderAmount?.toFixed(2)}</TableCell>
                      ) : val === "total_reffer_amount" ? (
                        <TableCell>
                          ${row?.totalClearedAmount?.toFixed(2)}
                        </TableCell>
                      ) : val === "total_commission" ? (
                        <TableCell sx={{ textAlign: "center" }}>
                          {/* $ {//row.commission} */}% 5
                        </TableCell>
                      ) : val === "total_amount" ? (
                        <TableCell>${row.totalClearedAmount}</TableCell>
                      ) : val === "Categorie_data" ? (
                        <TableCell>{row.name}</TableCell>
                      ) : val === "Faq_Title" ? (
                        <TableCell>{row.title}</TableCell>
                      ) : val === "Banner_Image" ? (
                        <TableCell>
                          <Stack
                            height={60}
                            width={90}
                            borderRadius={2}
                            overflow={"hidden"}
                          >
                            <img
                              src={row?.imageUrl}
                              height={"100%"}
                              width={"100%"}
                            />
                          </Stack>
                        </TableCell>
                      ) : val === "Faq_Description" ? (
                        <TableCell>{row.description}</TableCell>
                      ) : val === "bbShare" ? (
                        <TableCell>{row.bbShare}%</TableCell>
                      ) : val === "customerShare" ? (
                        <TableCell>{row.customerShare}%</TableCell>
                      ) : val === "vendorShare" ? (
                        <TableCell>{row.vendorShare}%</TableCell>
                      ) : val === "payment_data" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Chip label="stripe" className="stripe-tab" />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.vendorDetails?.name}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row.vendorDetails?.email}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "actions" ? (
                        <TableCell>
                          <IconButton
                            className="action-button"
                            onClick={(event) => handleOpenMenu(event, index)}
                          >
                            <img src={APP_ICONS.ellipsisIcon} width={20} />
                          </IconButton>
                          {anchorEl?.index === index && (
                            <Menu
                              anchorEl={anchorEl.el}
                              open={Boolean(anchorEl)}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "center",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "center",
                              }}
                              sx={{
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                              }}
                              PaperProps={{
                                sx: {
                                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                  "&.MuiMenuItem-root": {
                                    textAlign: "center",
                                  },
                                },
                              }}
                            >
                              {showUserMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/vendor-profile", {
                                        state: row,
                                      });
                                    }}
                                  >
                                    View Profile
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      handleUpdateStatus(row, "Active");
                                    }}
                                  >
                                    Active
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      handleUpdateStatus(row, "InActive");
                                    }}
                                  >
                                    InActive
                                  </MenuItem>
                                </>
                              )}
                              {showAdminMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      handleUpdateStatus(
                                        row,
                                        "Return Accepted"
                                      );
                                    }}
                                  >
                                    Accepted
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      handleUpdateStatus(
                                        row,
                                        "Return Rejected"
                                      );
                                    }}
                                  >
                                    Rejected
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      handleUpdateStatus(
                                        row,
                                        "Return Refunded"
                                      );
                                    }}
                                  >
                                    Refunded
                                  </MenuItem>
                                </>
                              )}
                              {showEditAndDelete && (
                                <Stack>
                                  {showEdit && (
                                    <Stack width={100} alignItems={"center"}>
                                      <Button
                                        variant="outlined"
                                        onClick={() => {
                                          handleEdit(row);
                                          handleCloseMenu();
                                        }}
                                        sx={{ width: 85, height: 30 }}
                                        startIcon={
                                          <img
                                            src={APP_ICONS.editIconBlue}
                                            width={20}
                                          />
                                        }
                                      >
                                        Edit
                                      </Button>
                                    </Stack>
                                  )}
                                  {showDelete && (
                                    <Stack width={100} alignItems={"center"}>
                                      <Button
                                        variant="outlined"
                                        onClick={() => {
                                          handleDelete(row._id);
                                          handleCloseMenu();
                                        }}
                                        sx={{ width: 85, height: 30, mt: 1 }}
                                        startIcon={
                                          <img
                                            src={APP_ICONS.editIconBlue}
                                            width={20}
                                          />
                                        }
                                      >
                                        Delete
                                      </Button>
                                    </Stack>
                                  )}
                                </Stack>
                              )}
                              {showVendorMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/vendor-profile", {
                                        state: row,
                                      });
                                    }}
                                  >
                                    View Profile
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      handleUpdateStatus(row, "Active");
                                    }}
                                  >
                                    Active
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      handleUpdateStatus(row, "InActive");
                                    }}
                                  >
                                    InActive
                                  </MenuItem>
                                </>
                              )}
                              {showWithDrawnMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/vendor-profile", {
                                        state: row,
                                      });
                                    }}
                                  >
                                    View
                                  </MenuItem>
                                  <MenuItem onClick={handleCloseMenu}>
                                    Approved
                                  </MenuItem>
                                  <MenuItem onClick={handleCloseMenu}>
                                    Reject
                                  </MenuItem>
                                </>
                              )}
                              {showCommissionMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/vendor-profile", {
                                        state: row,
                                      });
                                    }}
                                  >
                                    View
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/vendor-profile", {
                                        state: row,
                                      });
                                    }}
                                  >
                                    Edit
                                  </MenuItem>
                                </>
                              )}
                              {showRequestMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                    }}
                                  >
                                    Approve
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                    }}
                                  >
                                    Reject
                                  </MenuItem>
                                </>
                              )}
                            </Menu>
                          )}
                        </TableCell>
                      ) : (
                        <TableCell>
                          <Typography lineHeight="normal" fontSize={"1rem"}>
                            {row[val]}
                          </Typography>
                        </TableCell>
                      )}
                    </React.Fragment>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {showPagination && (
          <TablePagination
            rowsPerPageOptions={[10, 20, 30, 40]}
            component="div"
            count={tableData?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
        <ImageViewDialog ref={openDialog} handleSuspend={handleSuspend} />
      </TableContainer>
    </>
  );
}
